/**
 * Pre-compiled fr-FR messages for Pagination
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  currentPage: `Page actuelle`,
  goToNextPage: `Aller à la page suivante`,
  goToPreviousPage: `Aller à la page précédente`,
  itemsPerPage: `Articles par page`,
  itemsPerPageText: `Articles par page`,
  ofTotalPages: (args: Record<string, string | number>) =>
    `de ${args.totalPages}`,
  page: `Page`,
  pagination: `Pagination`,
};
